import { useEffect, useState } from "react";
import { appliquerBaremeConsole, appliquerCarte10Console, appliquerParametresConsole, appliquerPassesConsole, appliquerStagesConsole } from "./pricing";
import { appliquerStagesConsoleFiches } from "./stages";
import { appliquerAuditionConsole } from "./auditions";
import { appliquerCalendrierConsole } from "./vacancesScolaires";
import { appliquerBasculeSpectacle, rafraichirSaison } from "./dates";
import { appliquerCoursPrivesConsole } from "./reglesPrives";

// Réglages saisis par l'école DANS LA CONSOLE (Réglages) et servis par `GET /api/reglages` :
// portes ouvertes, prix du cours d'essai, grille de tarifs, montants de règlement (taxe,
// réductions, costumes, parrainage, accumulation), prix des pass illimités, date de
// l'audition, catalogue des stages, nombre d'élèves actifs et cours privés (durées, prix,
// conditions d'annulation — Réglages › Cours privés, 02.11.2026). Aucune de ces valeurs n'est
// écrite dans le site : elles sont appliquées sur place dès leur arrivée, et les valeurs de
// repli des modules restent en place si la console ne répond pas. Lecture unique par
// visite, partagée par les pages.
const VIDE = { portes_ouvertes: [], prix_essai: null, tarifs_enfants: null, tarifs_adultes: null,
  eleves_actifs: null, audition_date: "" };

let cache = null;
let enCours = null;

export function chargerReglages() {
  if (cache) return Promise.resolve(cache);
  if (!enCours) {
    enCours = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/reglages`)
      .then((r) => (r.ok ? r.json() : VIDE))
      .then((d) => {
        appliquerBaremeConsole(d?.tarifs_enfants, d?.tarifs_adultes);
        appliquerParametresConsole(d?.parametres, d?.accumulation);
        appliquerStagesConsole(d?.stages);
        appliquerStagesConsoleFiches(d?.stages);
        appliquerAuditionConsole(d?.audition_date);
        appliquerCarte10Console(d?.carte_10);
        appliquerPassesConsole(d?.pass);
        appliquerCalendrierConsole(d?.calendrier);
        appliquerBasculeSpectacle(d?.date_limite_spectacle);
        appliquerCoursPrivesConsole(d?.cours_prives);
        rafraichirSaison();
        cache = {
          portes_ouvertes: Array.isArray(d?.portes_ouvertes) ? d.portes_ouvertes : [],
          prix_essai: d?.prix_essai ?? null,
          tarifs_enfants: d?.tarifs_enfants || null,
          tarifs_adultes: d?.tarifs_adultes || null,
          eleves_actifs: Number(d?.eleves_actifs) || null,
          audition_date: d?.audition_date || "",
          date_limite_spectacle: d?.date_limite_spectacle || "",
          carte_10: d?.carte_10 || null,
          pass: Array.isArray(d?.pass) ? d.pass : [],
          cours_prives: d?.cours_prives || null,
        };
        enCours = null;
        return cache;
      })
      .catch(() => {
        enCours = null;
        return VIDE;
      });
  }
  return enCours;
}

export function useReglages() {
  const [reglages, setReglages] = useState(cache || VIDE);
  useEffect(() => {
    let annule = false;
    chargerReglages().then((d) => {
      if (!annule) setReglages(d);
    });
    return () => {
      annule = true;
    };
  }, []);
  return reglages;
}
